// extracted by mini-css-extract-plugin
module.exports =  {"root":"fkMieMSrNJkiKFI9adIr","icon":"tVveL6_hoRP4Ydy1HGtz","subtext":"qvcxDoMugUjOPBk7SEGj","tags":"QdNlkG6ju1EtPaUqp0Y5"};